<template>
  <main class="w-full">
    <cms-section v-if="section?.items?.length" class="mb-4" :section />
    <h1 v-if="!titleBelowBreadcrumb" class="mb-6 text-left title-1">
      {{ headerTitle }}
    </h1>
    <base-grid :cols="{ sm: 2, lg: 3 }" gap="md">
      <vf-tile v-for="(tile, key) in tiles" :key v-bind="tile" :spacing="tileSpacing" />
    </base-grid>
  </main>
</template>

<script lang="ts" setup>
const emit = defineEmits<{
  'change-page-title': [title: string]
}>()

const { titleBelowBreadcrumb, tileSpacing } = useAppConfig().pages.help
const { data, error } = await useApi().internal.getStaticPage('help/faq')
const [section] = (await useCms().getSections.generic('faq')).data.value?.content.sections || []
const { $feature } = useNuxtApp()

if (!data.value) throw createError({ ...error.value!, fatal: true })

const { headerTitle } = data.value

emit('change-page-title', headerTitle)

const tiles = data.value.tiles.filter((tile) => {
  if (tile.icon === 'family') return $feature.enableLoyaltyFeatures
  if (tile.icon === 'customs') return $feature.enableCustoms

  return true
})
</script>
